import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";

import { logout } from "auth/modules/actions";

export const authMiddleware: Middleware = (mwApi: MiddlewareAPI) => (next: Dispatch) => <A extends AnyAction>(action: A) => {
    // Phase 1
    // if the error code is 401, log the user out
    if (action.payload && action.payload.isError && action.payload.message) {
        if (action.payload.message.indexOf("Code: 401") !== -1 || action.payload.message.indexOf("Login Required") !== -1) {
            // I think here we lose the redirect after the log back in.
            mwApi.dispatch(logout());
            return;
        }
    }

    // Phase 2
    // TODO: detect if the Action is an error
    // TODO: pause all actions
    // TODO: refresh that token
    // TODO: retry initial request
    // TODO: resume action queue

    return next(action);
};
